import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";

export const checkoutAuthGuard: CanActivateFn = (_route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    if (auth.isLoggedIn) {
        return true;
    }
    return router.createUrlTree(["/auth/signup"], {
        queryParams: { returnUrl: state.url },
    });
};
